import { render, staticRenderFns } from "./SeriesProfile.vue?vue&type=template&id=1a0f2dee"
import script from "./SeriesProfile.vue?vue&type=script&lang=js"
export * from "./SeriesProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports